//Please add the language resource
const company = {
  companyName:'机构名称',
  activeOff: '是否启用',
  companyCode: '机构编码',
  companyShortName: "机构简称",
  menu: '上级菜单',
  msg:{
    deleteCompany: '确认删除该机构吗？',
    companyCode: '请输入机构编码',
    parentCompanyCode: '请选择上级菜单',
    companyName: '请输入机构名称',
  }
};
export default company



// WEBPACK FOOTER //
// ./src/page/mdm/company/lang/company.en.js